module.exports = __webpack_public_path__ + "img/italy-lung-cancer-male.c74d6ff4.png";